let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2Kkkj")).then(() => parcelRequire('koRJI'));